import { api } from '@services';

import { IInvite } from '@models/Invite.model';

interface IPatchInvite {
  id: string;
  canceled?: boolean;
}

const patchInvite = async ({
  id,
  canceled,
}: IPatchInvite): Promise<IInvite> => {
  const { data: invite } = await api.patch<IInvite>(`/invites/${id}/canceled`, {
    canceled,
  });

  return invite;
};

export { patchInvite };
